import './App.css';
//cspell:disable
import Navigation from './Navigation';

import Nav2 from './Nav2';
import Header from './Header';
import {BrowserRouter,Routes,Route} from "react-router"
import Home from './Home';
import Newmaterial from './Newmaterial';
import Women from './Women';
import Men from './Men';
import BG from './BG';
import Fragrance from './Fragrance';
import Makup from './Makup';
import Skin from './Skin'
import Catu from './Catu';
import Hader from './Component/Hader';
import Footer from './Component/Footer';
import React, { useState,useEffect } from 'react';
import Addtodo from './Component/Addtodo';
import Todos from './Component/Todos';
import Firstpic from './Components/Firstpic';
import Secpic from './Components/Secpic'
import Thirpic from './Components/Thirpic';
import Forpic from './Components/Forpic';
import Fivpic from './Components/Fivpic';
import Sixpic from './Components/Sixpic';
import Sevpic from './Components/Sevpic';
import Eighpic from './Components/Eighpic';
import Crew from './Components/Crew';
import Sign from './Components/Sign';
import Track from './HeaderComponent/Track';
import Forgot from './HeaderComponent/Forgot';
import Create from './HeaderComponent/Create';
import Corporate from './HeaderComponent/Corporate';
import Page1 from './HeaderComponent/Page1';
import Page2 from './HeaderComponent/Page2';
import Contact from './FoterComponent/Contact';
import Delivery from './FoterComponent/Delivery';
import Payment from './FoterComponent/Payment';
import Return from './FoterComponent/Return';
import Term from './FoterComponent/Term';
import Privacy from './FoterComponent/Privacy';
import Us from './FoterComponent/Us';
import Store from './FoterComponent/Store';
import Gift from './FoterComponent/Gift';
import Green from './pageO/Green';
import Information from './pageO/Information';
import Green1 from './pageO/Green1';
import SearchSlidePanel from './HeaderComponent/FullScreenOverlay';
import FullScreenOverlay from './HeaderComponent/FullScreenOverlay';
import CartSidebar from './HeaderComponent/CartSidebar';
import Image from './Image';
import AccountCreated from './HeaderComponent/AccountCreated';
function App() {

 


let initTodo;
if( localStorage.getItem("todos")===null){
  initTodo=[];
}else{
  initTodo=JSON.parse( localStorage.getItem("todos"))
}

  const onDelete = (todo)=>{
    console.log("i am on delete",todo);
     setTodos(todos.filter((e)=>{
       return e!==todo;
     }));
     localStorage.setItem("todos",JSON.stringify(todos));
    }

const addTodo= (title,desc)=>{
 console.log("i am adding todo ",title,desc)
 let sno;
 if(todos.length===0){
  sno=0;
 }else{
  let sno=todos[todos.length-1].sno+1;
 }
 
  const myTodos={
    sno:sno,
    title:title,
desc:desc
  }
  setTodos([...todos,myTodos]);
console.log(myTodos)}


  const [todos, setTodos] = useState(initTodo)
  useEffect(() => {
    localStorage.getItem("todos",JSON.stringify(todos))
  }, [todos])
  return (
    <div className="App">
      
     {/* <Hader title="My Todo List"/> 
     <Addtodo  addTodo={addTodo}/>
     <Todos todos={todos} onDelete={onDelete}/>
     <Footer/>  */}
      
      
    <BrowserRouter>
    {/* <Header/> */}
{/* <br /> <br /> <br /> <br /> */}
    {/* <Navigation/> */}
    {/* <Image/> */}
    <Nav2/>
     
    <Routes>
       <Route path='/' element= {<Home/>}></Route> 
       <Route path='/new material' element= {<Newmaterial/>}></Route> 
       <Route path='/women' element= {<Women/>}></Route> 
       <Route path='/crew' element= {<Crew/>}></Route> 
       <Route path='/men' element= {<Men/>}></Route> 
       <Route path='/bg' element= {<BG/>}></Route> 
       <Route path='/fragrance' element= {<Fragrance/>}></Route> 
       <Route path='/makup' element= {<Makup/>}></Route> 
       <Route path='/skin' element= {<Skin/>}></Route>
       <Route path='/catu' element= {<Catu/>}></Route> 
       <Route path='/firstpic' element= {<Firstpic/>}></Route> 
       <Route path='/secpic' element= {<Secpic/>}></Route> 
       <Route path='/thirpic' element= {< Thirpic/>}></Route> 
       <Route path='/forpic' element= {< Forpic/>}></Route> 
       <Route path='/fivpic' element= {< Fivpic/>}></Route> 
       <Route path='/sixpic' element= {< Sixpic/>}></Route> 
       <Route path='/sevpic' element= {< Sevpic/>}></Route> 
       <Route path='/eighpic' element= {< Eighpic/>}></Route> 
       <Route path='/sign' element= {<Sign/>}></Route>
       <Route path='/track' element= {<Track/>}></Route>yy
       <Route path='/forgot' element= {<Forgot/>}></Route>
       <Route path='/create' element= {<Create/>}></Route>
       <Route path='/corporate' element= {<Corporate/>}></Route>
       <Route path='/page1' element= {<Page1/>}></Route>
       <Route path='/page2' element= {<Page2/>}></Route>
       <Route path='/contact' element= {<Contact/>}></Route>
       <Route path='/delivery' element= {<Delivery/>}></Route>
       <Route path='/payment' element= {<Payment/>}></Route>
       <Route path='/return' element= {<Return/>}></Route>
       <Route path='/term' element= {<Term/>}></Route>
       <Route path='/privacy' element= {<Privacy/>}></Route>
       <Route path='/us' element= {<Us/>}></Route>
       <Route path='/store' element= {<Store/>}></Route>
       <Route path='/gift' element= {<Gift/>}></Route>
       <Route path='/green' element= {<Green/>}></Route>
       <Route path='/information' element= {<Information/>}></Route>
       <Route path='/green1' element= {<Green1/>}></Route>
       <Route path='/fullScreenOverlay' element= {<FullScreenOverlay/>}></Route>
       <Route path='/cartSidebar' element= {<CartSidebar/>}></Route>
       <Route path="/account-created" element={<AccountCreated/>} />















       </Routes>    
</BrowserRouter>



       
    </div>
  );
}

export default App;

